import {ErrorMap} from "../../models/ErrorMap";
import {httpClient} from "../../utils/http/httpClient";
import {API} from "../../environment/api";
import {catchError, map, throwError} from "rxjs";

export function getStatisticsApi(
    queryName: string,
    setError: (err: ErrorMap) => void,
) {
    return httpClient.get(API.statistics.list, {pathParams:{queryName}}).pipe(
        map((res) => res.data),
        catchError((err) => {
            setError({
                statusCode: err.statusCode,
                message: err.message,
                extra: err.extra,
            });
            return throwError(err);
        }),
    );
}

export function getStatisticsFileApi(
    queryName: string,
    id:string,
    setError: (err: ErrorMap) => void,
) {
    return httpClient.get(API.statistics.get,{pathParams:{queryName, id}}).pipe(
        map((res) => res.data),
        catchError((err) => {
            setError({
                statusCode: err.statusCode,
                message: err.message,
                extra: err.extra,
            });
            return throwError(err);
        }),
    );
}
